/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FirmDailyNavConfigVersion = {
  readonly id?: number;
  firm: number;
  effective_from: string;
  effective_to?: string | null;
  cap_iq_one_day_delta: string;
  cap_iq_five_day_delta: string;
  cap_iq_since_last_valuation_delta: string;
  secondary_one_day_delta: string;
  secondary_five_day_delta: string;
  secondary_since_last_valuation_delta: string;
  notification_recipients?: any;
  trading_calendar: FirmDailyNavConfigVersion.trading_calendar;
  readonly created_by_name?: string;
  readonly is_active?: boolean;
  readonly created_at?: string;
};
export namespace FirmDailyNavConfigVersion {
  export enum trading_calendar {
    XNYS = 'XNYS',
    XNAS = 'XNAS',
    XTSE = 'XTSE',
    XLON = 'XLON',
    XETR = 'XETR',
    XPAR = 'XPAR',
    XTKS = 'XTKS',
    XHKG = 'XHKG',
    XASX = 'XASX',
  }
}

